import React, { useEffect, useState } from "react";
import Crown from "@Images/crown2.png";
import PRZButton from "../UI/PRZButton";
import RuleGroup from "./RuleGroup";
import { v4 as uuidv4 } from "uuid";
import Helpers from "@Apis/helpers";
import "./style.scss";

const AdvanceFilter = ({
  customFieldOptions,
  setAdvanceFilters,
  setOpenAdvanceProductFiltersDrawer,
  setOpenProductFiltersDrawer,
  customKey,
}) => {
  const [ruleGroups, setRuleGroups] = useState([
    { id: uuidv4(), type: "AND", rules: [{
      id: uuidv4(),
      cf_entity_id: "",
      field_type: "",
      operator: "",
      values: [],
    }] },
  ]);

  useEffect(() => {
    if (customKey) {
      let filterData = JSON.parse(localStorage.getItem(customKey))?.length > 0 ? JSON.parse(localStorage.getItem(customKey)) : [
          { id: uuidv4(), type: "AND", rules: [{
            id: uuidv4(),
            cf_entity_id: "",
            field_type: "",
            operator: "",
            values: [],
          }] },
        ];
        const activeCfIds = new Set(
          customFieldOptions.filter((option) => option.is_active && !option.is_system_field).map((option) => option.cf_id)
        );
        filterData[0].rules = filterData[0]?.rules[0]?.cf_entity_id ? filterData[0]?.rules?.filter((rule) => activeCfIds.has(rule.cf_id)) : filterData[0]?.rules;
      setRuleGroups(filterData);
    }
  }, [customKey]);

  const addRuleGroup = () => {
    ruleGroups?.length === 0 ? setRuleGroups((prev) => [...prev, { id: uuidv4(), type: "AND", rules: [{
      id: uuidv4(),
      cf_entity_id: "",
      field_type: "",
      operator: "",
      values: [],
    }] }]) :
    setRuleGroups((prev) => [...prev, { id: uuidv4(), type: "OR", rules: [{
      id: uuidv4(),
      cf_entity_id: "",
      field_type: "",
      operator: "",
      values: [],
    }] }])
  };

  const updateRuleGroup = (id, updatedGroup) => {
    setRuleGroups((prev) =>
      prev?.map((group) => (group?.id === id ? updatedGroup : group))
    );
  };

  const removeRuleGroup = (id) => {
    const copyRuleGroups = JSON.parse(JSON.stringify(ruleGroups)).filter((group) => group?.id !== id);
    copyRuleGroups?.length > 0 ? copyRuleGroups[0].type = "AND" : null;
    setRuleGroups(copyRuleGroups);
  };

  const applyAdvanceFilter = () => {
    const convertData = ruleGroups?.map((ruleGroup) => ({
      logical_operator: ruleGroup?.type,
      filters: ruleGroup?.rules?.map((rule) => ({
        cf_entity_id: rule?.cf_entity_id,
        operator: rule?.operator,
        values: rule?.values,
        field_type: rule?.field_type,
      })),
    }));

    let payload = {
      filters: convertData,
      logical_operator: "OR",
    };
    setAdvanceFilters(Helpers.objectToBase64(payload));
    setOpenAdvanceProductFiltersDrawer(false);
    setOpenProductFiltersDrawer ? setOpenProductFiltersDrawer(false) : null;
    localStorage.setItem(customKey, JSON.stringify(ruleGroups));
  };

  return (
    <div class="advance-filter__wrapper">
      <div className="advance-filter__rule-group">
        {ruleGroups?.map((group) => (
          <RuleGroup
            key={group?.id}
            group={group}
            updateRuleGroup={updateRuleGroup}
            removeRuleGroup={() => removeRuleGroup(group?.id)}
            customFieldOptions={customFieldOptions}
          />
        ))}
        <PRZButton onClick={addRuleGroup}>+ Add "Or" Rule Group</PRZButton>
      </div>
      <div className="custom-drawer__footer" style={{ width: '100%' }}>
        <div className="ant-col-md-12" style={{ marginTop: "0.5rem" }}>
          <div className="indent-barcode__wrapper" style={{ display: "flex" }}>
            <PRZButton
              type="primary"
              onClick={applyAdvanceFilter}
              className="rule-group-button"
            >
              Apply
            </PRZButton>
            {false && (
              <Popconfirm
                placement="topRight"
                title="This feature is not accessible within your current plan to use this feature contact us."
                onConfirm={() => window.Intercom("showNewMessage")}
                okText="Contact Us"
                cancelText="Cancel"
              >
                <img
                  className="barcode-restrict"
                  src={Crown}
                  alt="premium"
                  style={{
                    marginLeft: "8px",
                    marginTop: "5px",
                  }}
                />
              </Popconfirm>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvanceFilter;
